import React, { useState, useEffect } from 'react';

function TodayStatsCard({ zoneId, shift, date, onClick }) {
  const [stats, setStats] = useState({
    work: 0, sick: 0, absent: 0, dayoff: 0, vacation: 0, total: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!zoneId) {
      setLoading(false);
      return;
    }
    
    setLoading(true);
    fetch(
      `/api/attendance/stats?date=${date}&shift=${shift}&zone_id=${zoneId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    )
      .then((r) => r.json())
      .then((data) => {
        setStats(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [zoneId, shift, date]);

  if (loading) {
    return (
      <div className="vacation-card stats-card">
        <div className="vacation-icon">📊</div>
        <div className="vacation-info">
          <div className="vacation-label">Явка сегодня</div>
          <div className="vacation-value">…</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="vacation-card stats-card"
      onClick={onClick}
      title="Показать детали"
    >
      <div className="vacation-icon">📊</div>
      <div className="vacation-info">
        <div className="vacation-label">Явка сегодня</div>
       <div className="today-stats-grid">
  {stats.work > 0 && (
    <span className="today-stat-item stat-work">✅ {stats.work}</span>
  )}
  {stats.sick > 0 && (
    <span className="today-stat-item stat-sick">🤒 {stats.sick}</span>
  )}
  {stats.absent > 0 && (
    <span className="today-stat-item stat-absent">❌ {stats.absent}</span>
  )}
  {stats.dayoff > 0 && (
    <span className="today-stat-item stat-dayoff">🏖 {stats.dayoff}</span>
  )}
  {stats.vacation > 0 && (
    <span className="today-stat-item stat-vacation">🌴 {stats.vacation}</span>
  )}
</div>
      </div>
    </div>
  );
}

export default TodayStatsCard;
